const BASE = ['data_labels'];

export const ALL_DATA_LABELS_QUERY_KEYS = {
  getAllDataLabels: () => [...BASE] as const,
};
